import { ViewMode } from '../../types/types';
import { createControllerFactory } from '../BookOnline/controller';

export default createControllerFactory(ViewMode.WIDGET);
